module.exports = __webpack_public_path__ + "static/media/dictionnaire_image_presentation.ab5ff7a2.png";